import { createReducer, on } from '@ngrx/store';

import { appActions } from '../../app/app.actions';

import { UserListStateActions } from './user-list-state.actions';
import { userListInitialState, userListStateAdapter, UserListStateModel } from './user-list-state.model';

export const UserListStateReducer = createReducer(
  userListInitialState,
  on(appActions.switchCompany, (state, { companyUserId }): UserListStateModel => ({
    ...state,
    loggedInUserId: companyUserId,
  })),
  on(UserListStateActions.setLoggedInUserId, (state, { loggedInUserId }): UserListStateModel => ({
    ...state,
    loggedInUserId,
  })),
  on(UserListStateActions.fetchSuccess, (state, { users }): UserListStateModel => ({
    ...userListStateAdapter.setAll(users ?? [], state),
  })),
  on(UserListStateActions.setLoggedInUser, (state, { loggedInUser }): UserListStateModel => ({
    ...state,
    loggedInUser,
    isLoaded: true,
  })),
  on(UserListStateActions.updateLoggedInUserSuccess, (state, { update }): UserListStateModel => ({
    ...state,
    loggedInUser: state.loggedInUser ? { ...state.loggedInUser, ...update } : state.loggedInUser,
  })),
  on(UserListStateActions.fetchError, (state): UserListStateModel => ({
    ...state,
    isLoaded: true,
  }))
);
